import { combineReducers } from 'redux'

import addressStep from './address-step/address-step-reducer'
import companyStep from './company-step/company-step-reducer'
import legalResponsibleStep from './legal-responsible-step/legal-responsible-step-reducer'
import securityStep from './security-step/security-step-reducer'
import root from './onboarding-reducer'

const reducerMap = {
  root,
  addressStep,
  companyStep,
  legalResponsibleStep,
  securityStep,
}

export default combineReducers(reducerMap)
